import React, { useState, useCallback } from 'react';
import Tippy from 'utils/Tippy';

import { useOffersInfo } from 'modules/dispatching/service';

import MinervaInfo from 'modules/Common/Detail/StatusInfo/MinervaInfo/component';

const LoadingFallback = () => {
  return <>Loading</>;
};

const OfferStatusTooltipContent = ({ offersInfo }) => {
  return <MinervaInfo minervaInfo={offersInfo} />;
};

const OfferStatusTooltip = ({ className, itinerary, children }) => {
  const [mounted, setMounted] = useState(false);
  const itineraryId = itinerary?.id;
  const response = useOffersInfo(mounted ? itineraryId : null);

  const getContent = useCallback(() => {
    if (!itineraryId) {
      return <OfferStatusTooltipContent offersInfo={{ error: true }} itineraryId={null} />;
    }

    return !response ? <LoadingFallback /> : <OfferStatusTooltipContent offersInfo={response} />;
  }, [response, itineraryId]);

  const handleShow = useCallback(() => {
    setMounted(true);
  }, []);

  const handleHidden = useCallback(() => {
    setMounted(false);
  }, []);

  return (
    <>
      <Tippy
        className={className}
        appendTo={document.body}
        maxWidth={'none'}
        placement="bottom"
        offset={[0, 0]}
        theme="light"
        trigger="click"
        interactive={true}
        interactiveBorder={5}
        interactiveDebounce={50}
        onShow={handleShow}
        onHidden={handleHidden}
        content={mounted && getContent()}
      >
        {children}
      </Tippy>
    </>
  );
};

export default OfferStatusTooltip;
